/**
 * query-client — 应用级单例 TanStack QueryClient
 *
 * 抽成独立模块（原来内联在 App.tsx）是为了让 hook 外的纯函数（如 ~/hooks/use-auth 的 logout）
 * 也能拿到同一个 client 实例做缓存治理。
 *
 * 安全要点：换账号 / 退出登录时必须 `queryClient.clear()` —— 业务缓存按账户隔离不够（部分
 * query key 历史上固定不带 userId），同浏览器换账号会读到上一个账户的列表 / 会话 / 设备等数据
 * （缓存泄漏）。logout 统一清缓存是跨域的通用兜底（见 ProfilePage 与 docs/plans §五）。
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
